import React from 'react'
import PropTypes from 'prop-types'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [],
  modifiers: ['inverse', 'body', 'caption'],
  states: []
}

export default function Text(props) {
  const { body, caption, inverse, children, ...rest } = props
  return (
    <p {...rest} className={resolveProps(props, config, 'Text')}>
      {children}
    </p>
  )
}

Text.propTypes = {
  body: PropTypes.bool,
  caption: PropTypes.bool,
  inverse: PropTypes.bool,
  children: PropTypes.node
}
